/**
 * PlaceholderPage — заглушка для ещё не реализованных страниц.
 * В Фазе 0 — на ней держится весь UI. Постепенно заменяется реальными страницами.
 */
import { Construction } from 'lucide-react';

interface Props {
  title: string;
  phase: string;
}

export function PlaceholderPage({ title, phase }: Props) {
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="card max-w-md w-full text-center">
        <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-primary-500/10 flex items-center justify-center">
          <Construction className="w-8 h-8 text-primary-400" />
        </div>
        <h1 className="text-2xl font-semibold mb-2">{title}</h1>
        <p className="text-surface-400 text-sm mb-4">
          Эта страница появится в {phase}.
        </p>
        <p className="text-xs text-surface-500">
          Phase 0: каркас проекта. Backend и frontend соединены, БД создана, миграции применены.
        </p>
      </div>
    </div>
  );
}
